<template>
    <div class="maps text-center col-md-12 m-0 p-0" :style="{height:height + 'px'}">
      <div class="col-md-12 d-flex justify-content-between top m-0 p-0 px-3 pt-2 pb-0">
        <p class="m-0 p-0">Total expired bookings: {{failed_booking.length}}</p>
        <p class="m-0 p-0">
          {{mark.length}} 
          <span class="percent">({{percentage}}%)</span>
          Traceable, {{inactive.length}}
          <span class="percent">({{Inactivepercentage}}%)</span>
          Inactive, {{notFound.length}}
          <span class="percent">({{NotFoundpercentage}}%)</span>
          No GPS.</p>
        <div class="justify-content-between m-0 p-0">
          <select v-model="noofdays" @change="refresh" name="" id="" class="drop mb-3">
          <option value="1">Just Today</option>
          <option value="2">Last 1 days</option>
          <option value="3">Last 2 days</option>
          <option value="8oooono">Last 7 days</option>
        </select>
        <p @click="refresh" id="tooltip3" class=" refresh px-1 ml-3"><i class="fa fa-refresh" aria-hidden="true"></i>
        <span>Refresh</span>
        </p>
        <p class="m-0 p-0 ml-3">Total traced bookings: {{mark.length}}</p>
        </div>
      </div>
        <GmapMap
          :center="{lat:currentLocation.lat, lng:currentLocation.lng}"
          :zoom="15"
          style="width: 100%; height: 600px"
        >
       <GmapMarker
          :key="index"
          v-for="(m, index) in mark"
          :position="m.position"
          :clickable="true"
          :draggable="false"
          @click="showCard(m.vehicle, m.lastConnection)"
        />
        </GmapMap>

        <div class="o-card col-md-4 float py-3" style="color:white" v-bind:style="{'background':alertColor(selectedVehicleDetail[0].expiredDays)}">
         
          <p v-if="curentVehicle.length == 0">Please Select the vehicle</p>
          <div class="text-left" v-else>
          <p class="m-0 p-0 strong"><strong>{{selectedVehicleDetail[0].customerName}}</strong></p>
          <p class="m-0 p-0">Vehicle {{curentVehicle}} | Booking ID: {{selectedVehicleDetail[0].bookingId}}</p>
          <p class="labels m-0 p-0 pb-2">Last Seen: {{lastActive | moment("from", "now")}}</p>
          <p class="m-0 p-0">Expired {{selectedVehicleDetail[0].expiredDays}} days ago.</p>
          <p>Total Penalty: {{selectedVehicleDetail[0].totalPenalty | currency}}</p>
          <!-- <div class="label-exp">abcdd</div> -->
          </div>
           
           
           <!-- <p v-if="noOfDays(lastActive) == 0 && curentVehicle.length > 0">Few minutes ago.</p> -->
          <div class="d-flex col-md-12 justify-content-between m-0 p-0"> 
            <button class="ontrack btn" disabled @click="mobilize">MOBILIZE</button>
            <button class="ontrack btn" disabled @click="immobilize">IMMOBILIZE</button>
          </div>
        </div>
        <div class="loading" v-if="load">Loading&#8230;
          <p>Pulling Satellites..</p>
        </div>

    </div>
</template>
<script>
const axios = require('axios');
const moment = require('moment')
const mapMarker = require('../../../assets/marker.svg');
export default {
    components: {
    },
    data(){
      return{
        markerOptions: {
          url: mapMarker,
          size: {width: 30, height: 60, f: 'px', b: 'px',},
          scaledSize: {width: 30, height: 60, f: 'px', b: 'px',},
        },
        nearMe:[],
        currentLocation:'',
        percentage:0,
        Inactivepercentage:0,
        NotFoundpercentage:0,
        curentVehicle:'',
        card:true,
        failed_booking:[],
        mark:[],
        inactive:[],
        notFound:[],
        message:'initializing Satellite...',
        currentIndex:0,
        loadingMap:false,
        height:650,
        lastActive:20,
        noofdays:1,
        selectedVehicleDetail: [{'expiredDays' : 0}]
      }
    },
    beforeCreate(){
      this.height = window.innerHeight + 30
        this.$getLocation().then(x=>{
              this.currentLocation = x
            })     
    },
    mounted(){
            this.initialize()
            // setInterval(function () {
            //   this.maps();
            // }.bind(this), 120000);
    },
    methods:{
    alertColor(days){
      console.log(days)
      if (days == 0) {
        return '#5E33D8'
      } else if (days < 2 && days > 0) {
        return '#27ae60'
      } else if (days < 10 && days > 2) {
        return '#f1c40f'
      } else {
        return '#c0392b'
      }
    },
    refresh(){

        this.maps()
    },
    initialize(){
        axios.post('https://api.on-track.in/api/getBookingByQuery',{
          status:3,
          paymentStatus:1
        },{
            headers: {
                'Content-Type':  'application/json',
                'Authorization': 'Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI='
            }
        }).then(result => {
          this.failed_booking = result.data
          this.maps()
        }).catch(error => {
          alert(error)
        });
      },
      vehiclenearMe(){
        for(var i in this.mark){
        var x = this.distance(this.currentLocation.lat, this.currentLocation.lng,this.mark[i].position.lng, this.mark[i].position.lng, 'K')
        if(x < 20){
          this.nearMe.push(this.mark[i])
        }
        window.console.log('aaaaaaaaaaaaaaaaa')
      }
      },
      distance(lat1, lon1, lat2, lon2, unit){
          if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
          }
          else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
              dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
            if (unit=="K") { dist = dist * 1.609344 }
            if (unit=="N") { dist = dist * 0.8684 }
            return dist;
          }
      },
      showCard(id, time){
        this.card = true
        this.curentVehicle = id
        this.lastActive = time
        this.selectedVehicleDetail = this.failed_booking.filter(x=>{
          return x.registrationNumber === id
        })
        console.log(this.selectedVehicleDetail[0])
      },
      maps(){
        this.mark = []
        this.inactive = []
        this.notFound = []
        this.message = 'Loading Vehicle in Maps...'
        for(let i in this.failed_booking){
        axios.get('https://glacier.on-track.in/api/intellicar/'+this.failed_booking[i].registrationNumber,{
              headers: {
                  'Content-Type':  'application/json',
              }
          }).then(result => {
            if(result.data) {
              let y = this.noOfDays(result.data.time)
              // window.console.log(y)
              if(y < this.noofdays){
                this.mark.push(
                {
                position:{
                  "lat":result.data.lat, "lng":result.data.lng
                },
                "vehicle":this.failed_booking[i].registrationNumber,
                "lastConnection":result.data.time
                })      
              }else{
                this.inactive.push(
                  {
                position:{
                  "lat":result.data.lat, "lng":result.data.lng
                },
                "vehicle":this.failed_booking[i].registrationNumber,
                "lastConnection":result.data.time
                })      
              }      
                this.percentage = Math.round((this.mark.length / this.failed_booking.length)*100)
                this.Inactivepercentage = Math.round((this.inactive.length / this.failed_booking.length)*100)
              }else{
                this.notFound.push('Not Found')
                this.NotFoundpercentage = Math.round((this.notFound.length / this.failed_booking.length)*100)
              }
          }).catch((err)=>{
            this.notFound.push(err.data)
            this.NotFoundpercentage = Math.round((this.notFound.length / this.failed_booking.length)*100)
          })
        }
      },
      noOfDays(start){
                var startDate = moment(start)
                var endDate = moment()
                return endDate.diff(startDate, 'days')
            },
      mobilize(){
         axios.post('http://api.intellicar.in/api/ontrack/mobilize',{
            vehicleno:this.curentVehicle,
            token:this.intellicar_token
          },{
              headers: {
                  'Content-Type':  'application/json',
              }
          }).then(() => {
           alert('Successfully Mobilized.')
          }).catch(()=>{
            alert('Try again.')
          })
      },
      immobilize(){
         axios.post('http://api.intellicar.in/api/ontrack/immobilize',{
            vehicleno:this.curentVehicle,
            token:this.intellicar_token
          },{
              headers: {
                  'Content-Type':  'application/json',
              }
          }).then(() => {
           alert('Successfully Immobilized.')
          }).catch(()=>{
            alert('Try again.')
          })
      }

    },
    computed:{
      // failed_booking(){
      //   return this.$store.getters.expired_booking(0)
      // },
      intellicar_token(){
        return this.$store.state.intellicar_token
      },
      load(){
        if(this.notFound.length + this.mark.length + this.inactive.length === this.failed_booking.length){
          return false
        }else{
          return true
        }
        
      }
    }
}
</script>
<style scoped>
#tooltip3 { position: relative; }
#tooltip3 span { display: none; color: #000000; }
#tooltip3:hover span {
    display: block;
    position: absolute;
    width: 50px;
    height: auto;
    right: -55px;
    border-radius: 5px;
    font-size: 11px;
    top: 0px;
    color: #ffffff;
    background-color: rgb(0, 0, 0,0.8);
    padding: 5px 5px;
}
.refresh{
  color: black;
  background-color: white;
  border-radius: 10px;
  cursor: pointer;
}
.refresh:hover{
  color: white;
  background-color: black;
}
.percent{
  color: rgb(0, 255, 213);
  font-size: 10px;
}
.justify-content-between{
  display: flex;
  justify-content: space-between
}
@media only screen and (max-width: 600px) {
  .o-card {
    margin: 0 auto;
    position: absolute;
    top: 82% !important;
    left: 0% !important;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
  }

  .top{
    display: none !important
  }
}

.maps{
  font-size: 13px;
}
.ontrack{
  width: 48%;
  background-color: rgb(234,67,53);
  color:white;
}
.top{
  background-color: rgb(51,51,51);
  color:white;
  font-size: 13px;
}
.o-card {
    margin: 0 auto;
    position: absolute;
    top: 70%;
    left: 35%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
}

/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 999;
  height: 2em;
  width: 2em;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: '';
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.3);
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: '';
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 1500ms infinite linear;
  -moz-animation: spinner 1500ms infinite linear;
  -ms-animation: spinner 1500ms infinite linear;
  -o-animation: spinner 1500ms infinite linear;
  animation: spinner 1500ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.5) -1.5em 0 0 0, rgba(0, 0, 0, 0.5) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(0, 0, 0, 0.75) 1.5em 0 0 0, rgba(0, 0, 0, 0.75) 1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) 0 1.5em 0 0, rgba(0, 0, 0, 0.75) -1.1em 1.1em 0 0, rgba(0, 0, 0, 0.75) -1.5em 0 0 0, rgba(0, 0, 0, 0.75) -1.1em -1.1em 0 0, rgba(0, 0, 0, 0.75) 0 -1.5em 0 0, rgba(0, 0, 0, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.label-exp {
    width: 0;
    height: 0;
    border-top: 0px solid transparent;
    border-left: -1px solid #5E34D8;
    border-right: 94px solid #5E34D8;
    border-bottom: 70px solid transparent;
    position: absolute;
    top: 0;
    right: 0;
}
</style>